import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import LandingPage from '../components/LandingPage'
import '../styles/landing.css'

const rootElement = document.getElementById('landing-root')

if (rootElement) {
  const pageData = JSON.parse(rootElement.dataset.page || '{}')

  createRoot(rootElement).render(
    <StrictMode>
      <LandingPage pageData={pageData} />
    </StrictMode>,
  )
}
